import React from "react";
import { CHANGELOG_ENTRIES } from "./spotOrderingHelpContent";
import HelpSystemDialogShell from "./HelpSystemDialogShell";

function ChangelogEntryCard({ entry, index }) {
	return (
		<section
			data-help-section={entry.id}
			className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm md:p-6"
		>
			<div className="flex flex-wrap items-start justify-between gap-4 border-b border-slate-200 pb-5">
				<div className="min-w-0">
					<h3 className="mt-2 text-2xl font-bold text-slate-900">{entry.title}</h3>
					<p className="mt-3 max-w-4xl text-sm leading-6 text-slate-600">{entry.summary}</p>
				</div>
				{/* <div className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-semibold text-slate-600">
					{entry.dateLabel || "Add release date"}
				</div> */}
			</div>

			{entry.changes?.length > 0 ? (
				<div className="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
					{entry.changes.map((change) => (
						<div
							key={change}
							className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm leading-6 text-slate-600"
						>
							{change}
						</div>
					))}
				</div>
			) : null}
		</section>
	);
}

export default function ChangelogDialog({ open, onClose }) {
	return (
		<HelpSystemDialogShell
			open={open}
			onClose={onClose}
			title="SPOT Ordering System Update Log"
			subtitle="Use this log to track workflow updates, interface changes, and future release notes for the SPOT Ordering workflow."
			sections={CHANGELOG_ENTRIES}
		>
			{CHANGELOG_ENTRIES.map((entry, index) => (
				<ChangelogEntryCard key={entry.id} entry={entry} index={index} />
			))}
		</HelpSystemDialogShell>
	);
}
